import dayjs from 'dayjs';
import { get, post } from '../../../api/common';
import { DEFAULT_DATE_FORMAT } from './config';
export const getExpenseReportCreationOptions = async () => {
    const expenseReportOptionsResponse = await get('/InternalAPI/ExpenseReportCreation.asmx/ExpenseReportOptions');
    const expenseReportOptionsJson = await expenseReportOptionsResponse.json();
    if (!expenseReportOptionsResponse.ok) {
        throw new Error(JSON.stringify(expenseReportOptionsJson));
    }
    return expenseReportOptionsJson;
};
export const createExpenseReport = async (payload) => {
    const result = await post('/InternalAPI/ExpenseReportCreation.asmx/ExpenseReport', {
        expenseReportCreationPayload: payload
    });
    const resultJson = await result.json();
    if (!result.ok) {
        throw new Error(JSON.stringify(resultJson));
    }
    return resultJson;
};
export const getExpenseReportPreview = async (type, startDate, endDate, pCardIds = []) => {
    const urlSearchParamsObject = {
        type: type.toString(),
        startDate: dayjs(startDate).format(DEFAULT_DATE_FORMAT),
        endDate: dayjs(endDate).format(DEFAULT_DATE_FORMAT)
    };
    let params = new URLSearchParams(urlSearchParamsObject).toString();
    if (pCardIds.length > 0) {
        params += `&pCardIds=${pCardIds.join(',')}`;
    }
    else {
        params += `&pCardIds=`;
    }
    const result = await get(`/InternalAPI/ExpenseReportCreation.asmx/ExpenseReportPreview?${params}`, true);
    const resultJson = await result.json();
    if (!result.ok) {
        throw new Error(JSON.stringify(resultJson));
    }
    return resultJson;
};
export const getExpenseReportCreationViewModel = async () => {
    const result = await get('/InternalAPI/ExpenseReportCreation.asmx/ExpenseReportViewModel');
    const resultJson = await result.json();
    if (!result.ok) {
        throw new Error(JSON.stringify(resultJson));
    }
    return resultJson;
};
